export const deliveryTypesZH = {
  DINE_IN: '堂食',
  DINE_IN_PAID_BY_CUSTOMER: 'DimPay (堂食自助結帳)',
  TAKEAWAY: '餐廳外賣',
  STORE_DELIVERY: '點單外送',
  DIMORDER_TAKEAWAY: '點單外賣',
}
